const DrivingExceptions = {
    adjustDutyForShortHaulExceptions: function (param) {
        "use strict";

        let { eventType, exceptions } = param;

        const shorthaulLoggingEnabled = Vistracks.myAccount.accountProperties.shorthaulLogging,
            shorthaulLogging = shorthaulLoggingEnabled && shorthaulLoggingEnabled.value === "true";

        const shortHaulNoLogEnabled = _.includes(exceptions, "ShortHaulNoLog") ||
            _.includes(exceptions, "ShortHaulReadyMixed");

        if (shortHaulNoLogEnabled && !shorthaulLogging) {
            let _eventType = eventType;

            if (eventType === "Driving") {
                _eventType = "OnDuty";
            } else if (eventType === "WaitingAtSite" || eventType === "Sleeper") {
                _eventType = "OffDuty";
            }

            return _eventType;
        }

        return eventType;
    },

    getDescription: function (exceptionNames, region) {
        const descriptions = [];
        const exceptionsList = region === "Canada" ? this.canada : this.usa;
        const _exceptionNames = exceptionNames || [];

        _exceptionNames.forEach((exceptionName) => {
            const exception = exceptionsList.find((exceptionList) => {
                return exceptionList.exceptions === exceptionName;
            });

            if (exception) {
                descriptions.push(exception);
            }
        });

        return descriptions;
    },


    getDescriptionByExceptionType(exception) {
        const allExceptions = [...this.usa, ...this.canada];
        const description = allExceptions.find((exception) => {
            return exception.exceptions === exception;
        });

        return description ? description : '';
    },

    usa: [
        {
            exceptions: "AdverseDrivingConditions",
            description: Locale.translate("2 Hour Driving Extension for Adverse Driving Conditions"),
            subDescription: Locale.translate("395.1(b)(1) - Adverse Driving Conditions"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "Agricultural",
            description: Locale.translate("No logs for Agricultural Operations"),
            subDescription: Locale.translate("395.1(k) - Agricultural Operations"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "Asphalt30MinOnDutyBreak",
            description: Locale.translate("30 Minute OnDuty break for Asphalt drivers"),
            subDescription: Locale.translate("FR Vol83No18k - 30 Minute OnDuty Break"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "CaliforniaTankDriver",
            description: Locale.translate("California flammable tank drivers may drive 10 hours within a work shift"),
            subDescription: Locale.translate("13 CCR 1212.5(a) - California Tank Drivers"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "DriverSalesPerson",
            description: Locale.translate("Driver-salesperson whose total driving time does not exceed 40 hours in any period of 7 consecutive days"),
            subDescription: Locale.translate("395.1(c) - Driver-Salesperson"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "DrivingWindow16Hour",
            description: Locale.translate("16 Hour Work Shift Once Per Week"),
            subDescription: Locale.translate("395.1(o) - 16 Hours Driving Window"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "EmergencyConditions",
            description: Locale.translate("Relief from All Driving Rules for Emergency Conditions"),
            subDescription: Locale.translate("395.1(b)(2) - Emergency Conditions"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "HazMatInAttendanceBreak",
            description: Locale.translate("30 Minute in-attendance break for HazMat drivers"),
            subDescription: Locale.translate("395.1(q) - HazMat In-attendance Break"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "HiRail",
            description: Locale.translate("Hi-rail 2 hour travel exclusion"),
            subDescription: Locale.translate("395.1(w) - Hi-rail Vehicle"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "MichiganSeasonalConstruction",
            description: Locale.translate("Michigan seasonal construction 70/80 and may drive 12 hours during a 16 hour shift"),
            subDescription: Locale.translate("- Michigan Seasonal Construction"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "NotCmv",
            description: Locale.translate("No Logs for Non Commercial Motor Vehicle"),
            subDescription: Locale.translate("- Not-CMV"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "OilFieldOperations",
            description: Locale.translate("Oilfield Operations with 24 hour restart"),
            subDescription: Locale.translate("395.1(d) - Oilfield Operations"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "OversizeLoads",
            description: Locale.translate("30 Minute Break Exemption for Oversize/Overweight Loads"),
            subDescription: Locale.translate("395.3(a)(3)(ii) - Oversize/Overweight Loads"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "PetroleumNoBreak",
            description: Locale.translate("30 Minute Break Exemption for Petroleum Tank Drivers"),
            subDescription: Locale.translate("FR Vol83No68 - Petroleum Haulers No Break"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "ShortHaul12HourNoBreak",
            description: Locale.translate("30 Minute Break Exemption for Short-haul Drivers (14 hour shift)"),
            subDescription: Locale.translate("395.1(e)(1) - Short-haul No Break"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "ShortHaulNoBreak",
            description: Locale.translate("30 Minute Break Exemption for Short-haul Drivers (14 hour shift)"),
            subDescription: Locale.translate("395.1(e)(1) - Short-haul No Break"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "ShortHaulNoLog",
            description: Locale.translate("No Logs for CDL short-haul Drivers operating within 150 air miles (14 hour shift)"),
            subDescription: Locale.translate("395.1(e)(1) - Short-haul CDL No Logs"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "ShortHaulReadyMixed",
            description: Locale.translate("No Logs for short-haul Asphalt or Ready-Mixed Concrete Drivers operating within 100 air miles 395(e)(1) or Non-CDL drivers operating within 150 air miles 395(e)(2)"),
            subDescription: Locale.translate("395.1(e)(2) - Short-haul Non CDL/Ready-Mixed Concrete"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "StateOfEmergency",
            description: Locale.translate("Relief from Driving rules for State of Emergency"),
            subDescription: Locale.translate("390.23 - State of Emergency"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "TransportOfBeesOrLivestock",
            description: Locale.translate("30 Minute Break Exemption for Commercial Bees and Livestock haulers"),
            subDescription: Locale.translate("395.1(u,v) - Transport of Commercial Bees, Livestock"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "TwentyFourHourRestart",
            description: Locale.translate("24 Hour Restart for Construction, Groundwater well-drilling"),
            subDescription: Locale.translate("395.1(l,m) - 24 Hour Restart"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "UtilityServiceVehicle",
            description: Locale.translate("Relief from All Driving Rules for Utility Service Vehicles"),
            subDescription: Locale.translate("395.1(n) - Utility Service Vehicle"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        },
        {
            exceptions: "MinnesotaConstruction",
            description: Locale.translate("No Logs for Construction Equipment operating within 50-mile radius"),
            subDescription: Locale.translate("221.025 (8) - Minnesota Construction Equipment"),
            country: "USA",
            note: "USA driving exception",
            exceptionClass: "us-inspection-help-block"
        }
    ],

    canada: [
        {
            exceptions: "CanAdverseDrivingConditions",
            description: Locale.translate("2 Hour Driving Extension for Adverse Driving Conditions"),
            subDescription: Locale.translate("76(2,3) - Adverse Conditions"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "CanEmergencyConditions",
            description: Locale.translate("Relief from All Driving Rules for Emergency Conditions"),
            subDescription: Locale.translate("76(1) - Emergency Conditions"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "CanLocalNoLog",
            description: Locale.translate("No logs for drivers operating within 160km of home terminal"),
            subDescription: Locale.translate("81 - No Logs"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "CanOilWellServicePermit",
            description: Locale.translate("Oil Well Service Permit"),
            subDescription: Locale.translate("63 - Oil Well Service Permit"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "CanSpecialPermit",
            description: Locale.translate("2 Hour Driving Extension Special Permit"),
            subDescription: Locale.translate("62 - 2 Hour Driving Extension Permit"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "CanFerry",
            description: Locale.translate("Ferry Crossing More than 5 hours"),
            subDescription: Locale.translate("17 - Ferry Crossing More than 5 hours"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "Can14DayFertilizer",
            description: Locale.translate("Canadian Fertilizer Exemption"),
            subDescription: Locale.translate("16 - Canadian Fertilizer Exemption"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "AbReducedRestOption",
            description: Locale.translate("Reduce the required 8 hours of rest to no less than 4 hours once a week"),
            subDescription: Locale.translate("5(4) - Reduced Rest Option"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
         {
            exceptions: "OntarioSpecialVehicleOperations",
            description: Locale.translate("Exempts drivers from HOS rules when operating specific vehicles for farming, emergency, municipal, or crane-related activities."),
            subDescription: Locale.translate("555/06 (3) - Ontario Operational Use Exemption"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        },
        {
            exceptions: "OntarioVolunteerFireFighters",
            description: Locale.translate("2 hour exemption for volunteer firefighters"),
            subDescription: Locale.translate("555/06 (3.1) - Ontario Volunteer Firefighters Exemption"),
            country: "CANADA",
            note: "Canada driving exception",
            exceptionClass: "ca-inspection-help-block"
        }
    ]
};

/**
 *
 * @param {array} driverHistories Collection of driver history logs
 * @param {object} driverDaily Driver daily information of the previous log.
 * @param {string} region The region where the selected driver is associated with.
 * @returns {array} Collection of added exceptions.
 */
export function getAddedExceptions(driverHistories, driverDaily, region) {
    const exceptions = region === "Canada"
        ? DrivingExceptions.canada
        : DrivingExceptions.usa;

    const exceptionsList = exceptions.map(
        (exception) => ({
            exception: exception.exceptions,
            description: exception.description,
        })
    );

    /**
     * For backward compatibility in favor for the old version of the app,
     * lets determine if a particular history note starts with the word `Added`.
     * If it does, then the eventType of that particular driving history log
     * will be mark as `AddedExceptionRemark`.
     */
    const driverHistoryLogs = [...driverHistories].map((dh) => {
        return {
            ...dh,
            eventType: dh.eventType === "Remark" && !!dh.note && dh.note.startsWith("Added")
                ? "AddedExceptionRemark"
                : dh.eventType
        };
    });

    const drivingExceptions = [];
    const driverDailyExceptions =
        driverDaily && !!driverDaily.exceptions && driverDaily.exceptions
            ? driverDaily.exceptions
                .split(",")
                // We will exclude those exceptions that will not be carry over to the next day.
                .filter((exception) => {
                    return ![
                        "DrivingWindow16Hour",
                    ].includes(exception);
                })
            : [];

    const addedDrivingExceptions = driverHistoryLogs.filter((dh) =>
        [
            "StateOfEmergency",
            "AddedExceptionRemark",
            "AgriculturalOperations",
        ].includes(dh.eventType)
    );

    addedDrivingExceptions.forEach((drivingException) => {
        exceptionsList.forEach((exceptionList) => {
            if (
                !!drivingException.note &&
                drivingException.note.includes(exceptionList.exception)
            ) {
                drivingExceptions.push(exceptionList);
            }
        });
    });

    // Lets carried out those exceptions that was not removed in the previous day log into the next day log if
    // 1. ...the next day log has no added exception(s) or
    // 2. ...if the next day log has an added exception(s).
    if (!drivingExceptions.length || driverDailyExceptions.length) {
        exceptionsList.forEach((exceptionList) => {
            if (driverDailyExceptions.includes(exceptionList.exception)) {
                drivingExceptions.push(exceptionList);
            }
        });
    }

    // This will remove the duplicate exceptions.
    const filteredDrivingExceptions = [];
    drivingExceptions.filter((drivingException) => {
        const index = filteredDrivingExceptions.findIndex(
            (item) => item.exception === drivingException.exception
        );

        if (index <= -1) {
            filteredDrivingExceptions.push(drivingException);
        }

        return null;
    });

    return filteredDrivingExceptions;
}

export default DrivingExceptions;
